import React, { useState, useEffect, useCallback } from 'react';
import socketService from '../services/socketService';
import Layout from '../components/Layout';
import ResilientImage from '../components/ResilientImage';
import moment from 'moment-timezone';
import { useNavigate } from 'react-router-dom';

const PaymentSend = () => {
    const navigate = useNavigate();
    
    // URL Params
    const queryParams = new URLSearchParams(window.location.search);
    const usernameFromUrl = queryParams.get('username');

    // States সেকশনের নিচে এই লাইনটি যোগ করুন
const [regeneratedFromId, setRegeneratedFromId] = useState(null);
    // Device Selection Modal State
    const [showDeviceSelectionModal, setShowDeviceSelectionModal] = useState(false);

    // States
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [devices, setDevices] = useState([]);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    
    // Security Balance State
    const [checkCode, setCheckCode] = useState('');
    const [balanceInfo, setBalanceInfo] = useState(null);

    // Permissions State
    const [permissions, setPermissions] = useState({});
    const [isMaster, setIsMaster] = useState(false);

    // Modal States
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [changeDeviceModal, setChangeDeviceModal] = useState({ 
        show: false, 
        logId: null, 
        selectedDeviceInfo: '', 
        amount: 0,
        targetNumber: '', 
        type: ''          
    });
    const [cancelModal, setCancelModal] = useState({ show: false, logId: null });

    // 🔥 New Edit Modal State
    const [editModal, setEditModal] = useState({ 
        show: false, 
        logId: null, 
        status: '', 
        message: '' 
    });

    // Form States
    const [formData, setFormData] = useState({
        security_code: '',
        amount: '',
        number: '',
        device_info: '' 
    });

    const [filters, setFilters] = useState({
        search_code: '',
        search_number: '',
        search_type: '',   
        search_status: '', 
        start_date: '',
        end_date: '',
        page: 1,
        limit: 50
    });

    const [pagination, setPagination] = useState({ totalPages: 1, currentPage: 1, totalRows: 0 });
    const [totalSuccessAmount, setTotalSuccessAmount] = useState(0);

    const currentUser = users.find(u => u._id === selectedUser);

    // --- Helpers ---
// --- Helpers ---
    const getSimInfo = (simData) => {
        if (!simData) return null;
        if (typeof simData === 'object') {
            return { 
                number: simData.sim || "N/A", 
                // 🔥 এখানে filter যোগ করা হয়েছে যাতে 'hide' স্ট্যাটাসগুলো না দেখায়
                types: Array.isArray(simData.types) 
                    ? simData.types.filter(t => t.status !== 'hide') 
                    : [] 
            };
        }
        return { number: simData, types: [] };
    };

    // 🔥 NEW: Helper to get Logo based on Type (টেবিলের জন্য)
    const getServiceLogo = (type) => {
        if (!type) return '/logo.png';
        const tLower = type.toLowerCase();
        
        if (tLower.includes('bkash')) return '/bkash.jpg';
        if (tLower.includes('nagad')) return '/nagad.png';
        if (tLower.includes('whatsapp')) return '/whatsapp.png';
        
        return '/logo.png';
    };

    const fetchData = useCallback(() => {
        if (!selectedUser) return;
        setLoading(true);
        socketService.emit('get_payment_send_logs', { userId: selectedUser, ...filters });
    }, [selectedUser, filters]);

    // Load Permissions on Mount
    useEffect(() => {
        const masterStatus = localStorage.getItem('isMaster') === 'true';
        setIsMaster(masterStatus);

        try {
            const storedPerms = localStorage.getItem('permissions');
            if (storedPerms) {
                setPermissions(JSON.parse(storedPerms));
            }
        } catch (error) {
            console.error("Error parsing permissions", error);
        }
    }, []);

    // 🔥 NEW: Auto Fetch Balance Logic 
// 🔥 NEW: Auto Fetch Balance Logic 
useEffect(() => {
    const fetchBalance = setTimeout(() => {
        const storedMasterKey = localStorage.getItem('masterKey');
        const targetCode = formData.security_code ? formData.security_code : storedMasterKey; 
        
        // ⚠️ null করার লজিকটি এখান থেকে পুরোপুরি ডিলিট করা হয়েছে
        if (targetCode) {
            socketService.emit('check_security_code_balance', targetCode);
        }
    }, 500); 
    
    return () => clearTimeout(fetchBalance);
}, [formData.security_code]);

    useEffect(() => {
        if (usernameFromUrl && users.length > 0) {
            const userExists = users.find(u => u.username === usernameFromUrl);
            if (userExists) {
                const isMainAdmin = localStorage.getItem('isMaster') === 'true';
                let allowedUsers = [];
                try {
                    allowedUsers = JSON.parse(localStorage.getItem('allowedUsers') || '[]');
                } catch (e) { allowedUsers = []; }

                if (!isMainAdmin && allowedUsers.length > 0 && !allowedUsers.includes(userExists._id)) {
                    alert("⚠️ Access Denied!");
                    window.location.href = '/dashboard';
                    return;
                }
                setSelectedUser(userExists._id); 
            } else {
                alert('Invalid username in URL');
            }
        }
    }, [users, usernameFromUrl]);


    useEffect(() => {
        socketService.connect();
        socketService.emit('get_all_users');
        socketService.on('receive_all_users', (data) => setUsers(data || []));
        socketService.on('receive_active_devices', (data) => {
            setDevices(data || [])
        });

        socketService.on('receive_payment_send_logs', (data) => {
            setLogs(data.logs || []);
            setPagination({
                totalPages: data.totalPages || 1,
                currentPage: data.currentPage || 1,
                totalRows: data.totalRows || 0
            });
            setTotalSuccessAmount(data.totalSuccessAmount || 0);
            setLoading(false);
        });

        socketService.on('receive_code_balance', (data) => {
            if(data.success) setBalanceInfo(data);
            else setBalanceInfo(null);
        });

        socketService.on('error', (data) => alert(data.message));

        socketService.on('transaction_added_success', (data) => {
            alert(data.message);
            fetchData();
        });

        socketService.on('action_success', (data) => {
            alert(data.message);
            fetchData();
        });

        return () => {
            socketService.off('receive_all_users');
            socketService.off('receive_active_devices');
            socketService.off('receive_payment_send_logs');
            socketService.off('receive_code_balance');
            socketService.off('error');
            socketService.off('transaction_added_success');
            socketService.off('action_success');
        };
    }, [fetchData]);

    useEffect(() => {
        if (selectedUser) {
            socketService.emit('get_active_devices', selectedUser);
            fetchData();
        } else {
            setDevices([]);
            setLogs([]);
        }
    }, [selectedUser, fetchData]);

    const handleInputChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    // 🔥 UPDATED: Regenerate Function (Includes Security Code)
    const handleRegenerate = (log) => {
        setFormData({
            ...formData,
            amount: log.amount,
            number: log.number,
            security_code: log.security_code, // ✅ Code restored
            device_info: '', // Clear device so user selects new one
        });
        setRegeneratedFromId(log._id);
        // Scroll to top
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const handleCheckBalance = () => {
        if(!checkCode) return alert("Enter code");
        socketService.emit('check_security_code_balance', checkCode);
    };

    const handlePreSubmit = (e) => {
        e.preventDefault();
        if(!selectedUser) return alert("Please select a user!");
        if(!formData.device_info) return alert("Please select a device and type!");
        if(!formData.security_code) return alert("Security code required!");

        if (!balanceInfo) {
            return alert("Invalid security code! Please enter a valid code.");
        }

        if (balanceInfo.balance < Number(formData.amount)) {
            return alert("Insufficient balance!");
        }

        const isPending = logs.some(log => log.security_code === formData.security_code && ( log.status === 'executing'));
        if (isPending) {
            return alert("This Code already has a executing transaction!");
        }

        setShowConfirmModal(true);
    };

     const confirmAndSubmit = () => {
        try {
            if (!formData.device_info || !formData.device_info.includes('::')) {
                alert("Invalid Device Selection. Please select again.");
                setShowConfirmModal(false);
                return;
            }

            const [deviceId, slot, type] = formData.device_info.split('::');
            
            const device = devices.find(d => d._id === deviceId);
            let realSimNumber = "";
            
            if (device) {
                const info = getSimInfo(device[slot]);
                realSimNumber = info ? info.number : "";
            }

            const isMasterAdmin = localStorage.getItem('isMaster') === 'true';
        const storedMasterKey = localStorage.getItem('masterKey');

        // যদি সাব-এডমিন হয়, তাহলে তার ইনপুট করা checkCode আর লোকাল স্টোরেজের masterKey চেক করবে
        if (!isMasterAdmin) {
            if (formData.security_code !== storedMasterKey) {
                alert("⚠️ আপনার দেওয়া সিকিউরিটি কোডটি ভুল বা এটি আপনার কোড নয়!");
                return; // কোড ভুল হলে এখানেই থেমে যাবে, রিকোয়েস্ট পাঠাবে না
            }
        }

            const payload = {
                userId: selectedUser,
                deviceId,
                sim_number: realSimNumber,
                amount: Number(formData.amount),
                number: formData.number,
                type: type,
                security_code: formData.security_code,
                regeneratedFromId: regeneratedFromId,
                performedBy: localStorage.getItem('adminUsername') || 'Unknown'
            };
            
            socketService.emit('add_new_transaction', payload);
            setShowConfirmModal(false);
            setFormData({ ...formData, amount: '', number: '', security_code: '' });

        } catch (error) {
            console.error("Crash prevented in confirmAndSubmit:", error);
            alert("Something went wrong! Please refresh.");
            setShowConfirmModal(false);
        }
    };

    const handleCancelConfirm = () => {
        if (cancelModal.logId) {
            socketService.emit('cancel_transaction', cancelModal.logId);
            setCancelModal({ show: false, logId: null });
        }
    };

    // 🔥 Handle Edit Submit
    const handleEditSubmit = () => {
        if (!editModal.logId) return;

        socketService.emit('admin_update_transaction', {
            id: editModal.logId,
            status: editModal.status,
            message: editModal.message
        });

        setEditModal({ show: false, logId: null, status: '', message: '' });
    };

    const handleChangeDeviceSubmit = () => {
        if (!changeDeviceModal.selectedDeviceInfo) return alert("Select a device first");
        
        try {
            const parts = changeDeviceModal.selectedDeviceInfo.split('::');
            if(parts.length < 3) return alert("Invalid selection");

            const [deviceId, slot, type] = parts; 
            
            const device = devices.find(d => d._id === deviceId);
            let realSimNumber = "";
            if (device) {
                const info = getSimInfo(device[slot]);
                realSimNumber = info ? info.number : "";
            }

            socketService.emit('change_device_and_retry', {
                transactionId: changeDeviceModal.logId,
                deviceId: deviceId,
                sim_number: realSimNumber
            });
            setChangeDeviceModal({ show: false, logId: null, selectedDeviceInfo: '', amount: 0 });
        } catch (error) {
            console.error("Change Device Error:", error);
            alert("Failed to change device.");
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            setFilters(prev => ({ ...prev, page: newPage }));
        }
    };

    const getPageNumbers = () => {
        const total = pagination.totalPages;
        const current = pagination.currentPage;
        const maxVisibleButtons = 7;
        const pages = [];
        if (total <= maxVisibleButtons) {
            for (let i = 1; i <= total; i++) pages.push(i);
        } else {
            pages.push(1);
            let start = Math.max(2, current - 2);
            let end = Math.min(total - 1, current + 2);
            if (current <= 3) end = 5;
            else if (current > total - 3) start = total - 4;
            if (start > 2) pages.push('...');
            for (let i = start; i <= end; i++) pages.push(i);
            if (end < total - 1) pages.push('...');
            pages.push(total);
        }
        return pages;
    };

    return (
        <Layout>
             {/* CSS Styles */}
           
           <style>{`
    .main-content-area { background-color: #f4f7fa; min-height: 100vh; font-family: 'Inter', sans-serif; }
    
    .nav-tabs-container { 
        display: flex; 
        background: #ffffff; 
        padding: 15px 20px 0 20px; 
        border-bottom: 1px solid #e2e8f0; 
        margin-bottom: 20px; 
        gap: 15px; 
    }
    
    .nav-tab-item { 
        padding: 10px 25px; 
        font-size: 13px; 
        font-weight: 600; 
        color: #64748b; 
        cursor: pointer; 
        border: 1px solid transparent; 
        border-radius: 6px; 
        transition: all 0.2s ease; 
        text-transform: uppercase; 
        margin-bottom: 15px; 
    }

    .nav-tab-item:hover { 
        color: #0284c7; 
        background: #f8fafc;
    }

    .nav-tab-item.active { 
        color: #0284c7;           
        border: 1px solid #0284c7;
        background: #f0f9ff;      
        font-weight: 800; 
    }

    .section-title { color: #334155; font-weight: 700; }
    .count-badge { background: #fff; padding: 5px 15px; border-radius: 50px; border: 1px solid #e2e8f0; font-size: 13px; font-weight: 600; }
    .count-badge span { color: #0284c7; font-weight: 800; }
    .filter-card { background: #ffffff; padding: 20px; border-radius: 12px; }
    .field-label { font-size: 11px; font-weight: 700; color: #64748b; margin-bottom: 5px; }
    .modern-input { background: #f8fafc; border: 1px solid #cbd5e1; padding: 8px 12px; border-radius: 8px; font-size: 13px; width: 100%; outline: none; }
    .btn-apply { background: #0284c7; color: white; border-radius: 8px; font-size: 13px; transition: 0.3s; border: none; }
    .btn-apply:hover { background: #0369a1; transform: translateY(-1px); }
    .table-container { background: #ffffff; border-radius: 12px; overflow: hidden; }
    .custom-zebra-table { width: 100%; border-collapse: collapse; }
    .custom-zebra-table thead { background: #0284c7; color: #ffffffff; }
    .custom-zebra-table th { padding: 14px 15px; font-size: 11px; font-weight: 800; text-transform: uppercase; border-bottom: 2px solid #cbd5e1; text-align: left; }
    .custom-zebra-table tbody tr:nth-child(even) { background-color: #e2e8f0; }
    .custom-zebra-table tbody tr:hover { background-color: #edf2f7 !important; }
    .custom-zebra-table td { padding: 12px 15px; vertical-align: middle; border-bottom: 1px solid #edf2f7; }
    .pagination-btn { background: #fff; border: 1px solid #cbd5e1; color: #475569; padding: 4px 10px; font-size: 12px; font-weight: 600; border-radius: 6px; cursor: pointer; transition: 0.2s; min-width: 32px; }
    .pagination-btn:hover:not(:disabled) { background: #f1f5f9; border-color: #94a3b8; }
    .pagination-btn.active { background: #0284c7; color: #fff; border-color: #0284c7; }
    .pagination-btn:disabled { opacity: 0.5; cursor: not-allowed; }
    .user-primary { color: #0369a1; font-weight: 700; font-size: 14px; }
    .device-secondary { font-size: 10px; color: #64748b; font-weight: 800; background: #e2e8f0; display: inline-block; padding: 1px 6px; border-radius: 4px; margin-top: 3px; }
    .sim-num { color: #1e293b; font-weight: 600; font-size: 13px; }
    .sender-tag { color: #6366f1; font-weight: 800; font-size: 11px; }
    .msg-body { color: #334155; font-size: 13px; line-height: 1.5; }
    .date-bold { color: #334155; font-weight: 700; font-size: 13px; }
    .time-muted { font-size: 11px; color: #64748b; }
    .badge-status { padding: 4px 12px; border-radius: 6px; font-size: 11px; font-weight: 900; border: 1px solid transparent; }
    .bg-seen { background: #6a00f5ff; color: #f8fdfaff; border-color: #6a00f5ff; }
    .bg-fake { background: #fee2e2; color: #dc2626; border-color: #fecaca; }

    /* Custom Dropdown Styles */
.custom-select-box {
    position: relative;
    cursor: pointer;
    user-select: none;
}
.selected-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f8fafc; 
    border: 1px solid #cbd5e1; 
    padding: 8px 12px; 
    border-radius: 8px; 
    font-size: 13px;
    min-height: 42px; /* Height increased slightly for images */
}
.options-list {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: white;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    margin-top: 5px;
    max-height: 300px;
    overflow-y: auto;
    z-index: 1000;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
.option-item {
    padding: 10px 12px;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    transition: background 0.2s;
}
.option-item:hover {
    background: #f0f9ff;
}
.service-logo {
    width: 28px;
    height: 28px; /* Square size */
    object-fit: contain; /* Image will fit nicely */
    margin-right: 12px;
    border-radius: 50%; /* Optional: Circle logo */
    border: 1px solid #e2e8f0;
    background: white;
    padding: 2px;
}

    /* Modal Styles */
    .custom-modal-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(15, 23, 42, 0.6); z-index: 1050; display: flex; justify-content: center; align-items: flex-start; padding-top: 90px; backdrop-filter: blur(3px); overflow-y: auto; }
    .custom-modal { background: white; width: 90%; max-width: 420px; border-radius: 16px; overflow: hidden; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04); animation: modalSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1); margin-bottom: 50px; }
    @keyframes modalSlideIn { from { transform: translateY(-20px) scale(0.95); opacity: 0; } to { transform: translateY(0) scale(1); opacity: 1; } }
    .modal-header-custom { padding: 16px 24px; border-bottom: 1px solid #f1f5f9; display: flex; align-items: center; justify-content: space-between; }
    .modal-header-custom h5 { font-size: 16px; font-weight: 700; color: #334155; margin: 0; }
    .modal-body-custom { padding: 24px; }
    .modal-footer-custom { padding: 16px 24px; background: #f8fafc; border-top: 1px solid #f1f5f9; gap: 12px; }
    .modal-btn { border: none; padding: 10px 0; border-radius: 8px; font-size: 14px; font-weight: 600; transition: 0.2s; cursor: pointer; }
    .modal-btn.cancel { background: #e2e8f0; color: #475569; }
    .modal-btn.cancel:hover { background: #cbd5e1; }
    .modal-btn.confirm { background: #16a34a; color: white; box-shadow: 0 4px 6px -1px rgba(22, 163, 74, 0.2); }
    .modal-btn.confirm:hover { background: #15803d; transform: translateY(-1px); }
    .info-row { display: flex; justify-content: space-between; margin-bottom: 12px; font-size: 14px; color: #475569; border-bottom: 1px dashed #f1f5f9; padding-bottom: 8px; }
    .info-row:last-child { border-bottom: none; margin-bottom: 0; padding-bottom: 0; }
    .info-row span { font-weight: 500; }
    .info-row strong { font-weight: 700; color: #1e293b; }
`}</style>

            <div className="main-content-area py-3 px-4">
                
                {/* 🔥 TAB SYSTEM HEADER (CONDITIONAL) */}
                {usernameFromUrl && (
                    <div className="bg-white rounded-top shadow-sm mb-4">
                        <div className="nav-tabs-container mb-0">
                            <div 
                                className="nav-tab-item active"
                                onClick={() => {}} 
                            >
                                📤 Payment Send
                            </div>
                            <div 
                                className="nav-tab-item"
                                onClick={() => navigate(`/appreceive_user?username=${usernameFromUrl}`)}
                            >
                                📥 App Receive
                            </div>
                            <div 
                                className="nav-tab-item"
                                onClick={() => navigate(`/user_devices?username=${usernameFromUrl}`)}
                            >
                                📱 User Devices
                            </div>

                            <div 
                                className="nav-tab-item"
                                onClick={() => navigate(`/user_mobile_banking?username=${usernameFromUrl}`)}
                            >
                                💳 Mobile banking 
                            </div>
                                                       <div 
    className="nav-tab-item"
    // ✅ ফিক্স: এখানে user_devices এর পরিবর্তে api_keys হবে
    onClick={() => navigate(`/api_keys?username=${usernameFromUrl}`)}
>
    ⚙️ WD api config 
</div>
                            
                        </div>
                        
                     <div className="d-flex justify-content-between align-items-center p-3">
    
    <div className="d-flex align-items-center gap-3">
        <h4 className="section-title mb-0" style={{ fontSize: '18px' }}>
            Payment Dashboard: <span className="text-dark">{usernameFromUrl}</span>
        </h4>
         <a
            href="https://apibasenew.bdsoftpay.live/admin.apk"
            className="btn btn-dark shadow-sm d-flex align-items-center gap-2"
            style={{
                borderRadius: '30px',
                fontSize: '11px',
                fontWeight: '700',
                padding: '6px 16px',
                background: 'linear-gradient(45deg, #1e293b, #334155)',
                border: 'none',
                transition: 'all 0.3s ease'
            }}
        >
            <span style={{ fontSize: '14px' }}>📥</span>Admin Login Download APK
        </a>

        <a
            href="https://apibasenew.bdsoftpay.live/admin.apk"
            className="btn btn-dark shadow-sm d-flex align-items-center gap-2"
            style={{
                borderRadius: '30px',
                fontSize: '11px',
                fontWeight: '700',
                padding: '6px 16px',
                background: 'linear-gradient(45deg, #1e293b, #334155)',
                border: 'none',
                transition: 'all 0.3s ease'
            }}
        >
            <span style={{ fontSize: '14px' }}>📥</span>Payment GTW Download APK
        </a>


  <a
            href="https://apibasenew.bdsoftpay.live/app-release.apk"
            className="btn btn-dark shadow-sm d-flex align-items-center gap-2"
            style={{
                borderRadius: '30px',
                fontSize: '11px',
                fontWeight: '700',
                padding: '6px 16px',
                background: 'linear-gradient(45deg, #1e293b, #334155)',
                border: 'none',
                transition: 'all 0.3s ease'
            }}
        >
            <span style={{ fontSize: '14px' }}>📥</span>Chat Download APK
        </a>


    </div>

    {/* ডান পাশের অংশ: Total Count */}
    <div className="count-badge">Total: <span>{pagination.totalRows}</span></div>

{/* ছোট একটি CSS অ্যানিমেশন যোগ করা হলো */}
<style>{`
    @keyframes smoothPop {
        0% { opacity: 0; transform: scale(0.8) translateY(5px); }
        100% { opacity: 1; transform: scale(1) translateY(0); }
    }
    .animated-sum {
        display: inline-block;
        animation: smoothPop 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
`}</style>

<div className="count-badge" style={{ borderColor: '#16a34a', background: '#f0fdf4' }}>
    Success Sum: <span 
        key="verified-success-total"
        className="animated-sum" 
        style={{ color: '#ff0000ff', fontSize: '18px' }}
    >
        ৳{Number(totalSuccessAmount || 0).toLocaleString('en-BD', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
    </span>
</div>

</div>

                    </div>
                )}

                {/* DEFAULT HEADER (IF NO USERNAME) */}
                {!usernameFromUrl && (
                     <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="section-title mb-0">📤 Payment Send Dashboard</h4>
                        <div className="count-badge">Total Transactions: <span>{pagination.totalRows}</span></div>
                    </div>
                )}

                {selectedUser && (
                    <>
                      

                      <div className="row g-3 mb-4">
    <div className="col-12">
        <div 
            className="shadow-sm rounded-4 p-4 d-flex align-items-center justify-content-between flex-wrap gap-3" 
            style={{ 
                backgroundColor: '#ffffff', 
                border: '1px solid #e2e8f0', 
                borderLeft: '5px solid #0284c7' 
            }}
        >
            {/* বাম পাশ: Total Balance */}
            <div className="d-flex align-items-center gap-3">
                <div 
                    className="rounded-circle d-flex align-items-center justify-content-center shadow-sm" 
                    style={{ width: '55px', height: '55px', backgroundColor: '#f0f9ff', fontSize: '26px' }}
                >
                    🏦
                </div>
                <div>
                    <h6 className="mb-1 fw-bold text-uppercase" style={{ fontSize: '12px', color: '#64748b' }}>
                        TOTAL BALANCE {balanceInfo?.name ? <span style={{color: '#0284c7'}}>({balanceInfo.name})</span> : ''}
                    </h6>
                    <h2 className="fw-bolder mb-0 text-dark" style={{ fontSize: '26px', letterSpacing: '-0.5px' }}>
                        ৳{balanceInfo && balanceInfo.balance != null ? balanceInfo.balance.toLocaleString() : '0.00'}
                    </h2>
                </div>
            </div>

   
   {/* ডান পাশ: Withdraw Available */}
<div className="text-md-end text-start border-md-start ps-md-4 mt-2 mt-md-0" style={{ borderColor: '#f1f5f9' }}>
    <h6 className="mb-1 fw-bold text-uppercase d-flex align-items-center justify-content-md-end gap-2" style={{ fontSize: '12px', color: '#16a34a' }}>
        WITHDRAW AVAILABLE 
        <span className="badge" style={{ backgroundColor: '#16a34a', fontSize: '10px', borderRadius: '4px' }}>
            {/* 🔥 স্ট্যাটিক 80 রিমুভ করা হয়েছে, সরাসরি ডাটাবেসের ডাটা বসবে */}
            {balanceInfo?.withdrawPercent}%
        </span>
    </h6>
    
    <h2 className="fw-bolder mb-0" style={{ fontSize: '26px', color: '#15803d', letterSpacing: '-0.5px' }}>
        {/* 🔥 স্ট্যাটিক 80 রিমুভ করে সরাসরি ডাটাবেসের withdrawPercent দিয়ে হিসাব করা হচ্ছে */}
        ৳{balanceInfo && balanceInfo.balance != null && balanceInfo.withdrawPercent != null
            ? ((balanceInfo.balance * balanceInfo.withdrawPercent) / 100).toLocaleString() 
            : '0.00'
        }
    </h2>
    
    <small className="text-muted fw-semibold" style={{ fontSize: '11px' }}>Max limit for this account</small>
</div>


        </div>
    </div>
</div>

                     {/* Search Filter Card */}
<div className="filter-card mb-4 shadow-sm" style={{borderLeft: '5px solid #0077ffff',backgroundColor: '#eff6ff'}}>
    <div className="row g-2 align-items-end">
        {/* 1. Code */}
        <div className="col-md-2">
            <label className="field-label" style={{ color: '#0284c7' }}>SECURITY CODE</label>
            <input className="modern-input" placeholder="Code..." value={filters.search_code} onChange={(e) => setFilters({...filters, search_code: e.target.value, page: 1})} />
        </div>

        {/* 2. Number */}
        <div className="col-md-2">
            <label className="field-label">TARGET NUMBER</label>
            <input className="modern-input" placeholder="017..." value={filters.search_number} onChange={(e) => setFilters({...filters, search_number: e.target.value, page: 1})} />
        </div>

        {/* 3. Type */}
        <div className="col-md-1"> 
            <label className="field-label">TYPE</label>
            <select className="modern-input" style={{paddingRight: '0'}} value={filters.search_type} onChange={(e) => setFilters({...filters, search_type: e.target.value, page: 1})}>
                <option value="">All</option>
                <option value="bkash_App_cashin">Bkash</option>
            </select>
        </div>

        {/* 4. Status */}
        <div className="col-md-2">
            <label className="field-label">STATUS</label>
            <select className="modern-input" value={filters.search_status} onChange={(e) => setFilters({...filters, search_status: e.target.value, page: 1})}>
                <option value="">All Status</option>
                <option value="pending">Pending</option>
                <option value="executing">Executing</option>
                <option value="success">Success</option>
                <option value="failed">Failed</option>
                <option value="cancel">Canceled</option>
            </select>
        </div>

        {/* 5. Date Range */}
        <div className="col-md-3">
            <label className="field-label">DATE RANGE</label>
            <div className="d-flex gap-2">
                <input 
                    type="date" 
                    className="modern-input p-1" 
                    style={{cursor: 'pointer'}} 
                    value={filters.start_date} 
                    onChange={(e) => setFilters({...filters, start_date: e.target.value, page: 1})} 
                />
                <input 
                    type="date" 
                    className="modern-input p-1" 
                    style={{cursor: 'pointer'}} 
                    value={filters.end_date} 
                    onChange={(e) => setFilters({...filters, end_date: e.target.value, page: 1})} 
                />
            </div>
        </div>

        {/* 6. Search Button */}
        <div className="col-md-2 ps-3">
            <button className="btn-apply w-100 py-2" onClick={fetchData}>Search</button>
        </div>
    </div>
</div>

                   <div className="filter-card shadow-sm mt-4" style={{borderLeft: '5px solid #16a34a', backgroundColor: '#f0fdf4'}}>
                            <h5 className="field-label mb-3" style={{fontSize: '14px', color: '#16a34a'}}>➕ ADD NEW TRANSACTION</h5>
                            <form className="row g-2" onSubmit={handlePreSubmit}>
                                <div className="col-md-2">
                                    <label className="field-label">Code</label>
                                    <input name="security_code" value={formData.security_code} onChange={handleInputChange} className="modern-input" placeholder="Code" required />
                                </div>
                                <div className="col-md-2">
                                    <label className="field-label">Amount</label>
                                    <input name="amount" value={formData.amount} type="number" onChange={handleInputChange} className="modern-input" placeholder="Amount" required />
                                </div>
                                <div className="col-md-3">
                                    <label className="field-label">Number</label>
                                    <input name="number" value={formData.number} onChange={handleInputChange} className="modern-input" placeholder="Number" required />
                                </div>
                                
                                <div className="col-md-5">
    <label className="field-label">Device & Type</label>
    
    {/* Selection Box (Click to Open Modal) */}
    <div 
        className="modern-input d-flex align-items-center justify-content-between" 
        style={{ cursor: 'pointer', minHeight: '42px', background: '#fff' }}
        onClick={() => setShowDeviceSelectionModal(true)}
    >
        {formData.device_info ? (() => {
            const parts = formData.device_info.split('::');
            if(parts.length < 3) return <span>Invalid Selection</span>;
            
            const [devId, slot, type] = parts;
            const device = devices.find(d => d._id === devId);
            const simData = device ? (slot === 'sim1' ? getSimInfo(device.sim1) : getSimInfo(device.sim2)) : null;
            const maskedNum = simData && simData.number.length > 3 ? "***" + simData.number.slice(-3) : simData?.number;
            
            // Logo Logic
            let logoPath = '/logo.png';
            const tLower = type.toLowerCase();
            if(tLower.includes('bkash')) logoPath = '/bkash.jpg';
            else if(tLower.includes('nagad')) logoPath = '/nagad.png';
            else if(tLower.includes('whatsapp')) logoPath = '/whatsapp.png';

            return (
                <div className="d-flex align-items-center">
                    <ResilientImage src={logoPath} alt={type} className="service-logo" style={{width: '24px', height: '24px', marginRight: '10px'}} />
                    <div>
                        <span style={{fontWeight: '700', color: '#334155', fontSize: '13px'}}>
                            {device?.deviceName} 
                        </span>
                        <span className="text-muted ms-2" style={{fontSize: '12px'}}>
                            ({maskedNum}) - {type}
                        </span>
                    </div>
                </div>
            );
        })() : <span style={{color: '#94a3b8'}}>Select Device & Type...</span>}
        
        <span style={{fontSize: '12px', color: '#64748b'}}>▼</span>
    </div>
</div>
                             
                        <div className="col-12 text-end mt-3">
                                    <button type="submit" className="btn-apply py-2 px-5 fw-bold">Review & Send</button>
                                </div>
                            </form>
                        </div>

                        <div className="table-container shadow-sm mt-4">
                            <table className="custom-zebra-table">
                                <thead>
                                    <tr>
                                        <th>Amount</th>
                                        <th>Type & Number</th>
                                        <th>Device info</th>
                                        <th>Status</th>
                                        <th>Response</th>
                                        <th>Time</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {logs.length > 0 ? logs.map((log) => (
                                        <tr key={log._id}>
                                            <td><span className="user-primary">৳{log.amount}</span></td>
                                            
                                            {/* 🔥 এই অংশটি পরিবর্তন করা হয়েছে (টেবিলে লোগো যুক্ত করা হয়েছে) */}
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <ResilientImage
                                                        src={getServiceLogo(log.type)} 
                                                        alt="logo" 
                                                        style={{
                                                            width: '32px', 
                                                            height: '32px', 
                                                            borderRadius: '50%', 
                                                            marginRight: '10px',
                                                            border: '1px solid #e2e8f0',
                                                            padding: '2px',
                                                            objectFit: 'contain',
                                                            background: '#fff'
                                                        }} 
                                                    />
                                                    <div>
                                                        <div className="sim-num">{log.number}</div>
                                                        <div className="sender-tag text-uppercase" style={{fontSize: '10px', color: '#64748b'}}>
                                                            {log.type || 'N/A'}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td>
                                                <div className="sim-num">{log.deviceId?.deviceName || 'Unknown'}</div>
                                                <div className="device-secondary">{log.sim_number}</div>
                                            </td>
                                            <td>
                                                <span className={`badge-status ${log.status === 'success' ? 'bg-seen' : log.status === 'failed' ? 'bg-fake' : log.status === 'canceled' ? 'badge-unseen' : 'badge-unseen'}`} style={log.status === 'executing' ? {background: '#e0f2fe', color: '#0369a1'} : {}}>
                                                    {log.status ? log.status.toUpperCase() : 'UNKNOWN'}
                                                </span>
                                                <div style={{ fontSize: '11px', fontWeight: '700', color: '#64748b', marginTop: '4px' }}>
                                                    Code: ***{log.security_code ? log.security_code.slice(3) : 'N/A'}
                                                </div>
                                                {log.performedBy && (
                                                    <div style={{ fontSize: '10px', fontWeight: '700', color: '#7c3aed', marginTop: '2px', background: '#f5f3ff', display: 'inline-block', padding: '1px 6px', borderRadius: '4px' }}>
                                                        👤 {log.performedBy}
                                                    </div>
                                                )}
                                            </td>
                                            
                                          <td className="msg-body">
    {
        // ১. যদি ২ মিনিট পার হয়ে যায় এবং স্ট্যাটাস Pending/Executing থাকে -> "Time Out" দেখাবে
        (log.status === 'pending' || log.status === 'executing') && moment().diff(moment(log.createdAt), 'minutes') >= 2
        ? <span className="text-danger fw-bold" style={{color: '#dc2626'}}>Time Out must be check cashing sms</span>
        
        // ২. অন্যথায় আগের লজিক
        : (
            log.sms && log.sms !== 'Waiting...' 
            ? log.sms 
            : (
                log.status === 'cancel' || log.status === 'canceled' 
                ? <span className="text-muted">Transaction Canceled</span> 
                : 'Waiting...'
            )
        )
    }
</td>

                                            <td>
                                                <div className="date-bold">{moment(log.createdAt).format('MM-DD')}</div>
                                                <div className="time-muted">{moment(log.createdAt).format('hh:mm A')}</div>
                                            </td>
                                            <td>
                                                <div className="d-flex gap-1 align-items-center">
                                                   {(
    log.status === 'failed' || 
    ((log.status === 'pending' || log.status === 'executing') && moment().diff(moment(log.createdAt), 'minutes') >= 2)
) && (
    <>
        {/* 🔥 NEW Regenerate Button */}
        <button 
            className="btn btn-sm btn-dark text-white" 
            title="Copy data to form"
            onClick={() => handleRegenerate(log)}
        >
            Regenerate
        </button>
    </>
)}
                                                    {/* 🔥 EDIT BUTTON: Only visible if Master or Permission Granted */}
                                                    {(isMaster || permissions.permissonPaymentSendEdit) && (
                                                        <button 
                                                            className="btn btn-sm btn-secondary ms-1"
                                                            style={{ fontSize: '10px', padding: '4px 8px' }}
                                                            onClick={() => setEditModal({ 
                                                                show: true, 
                                                                logId: log._id, 
                                                                status: log.status, 
                                                                message: log.sms 
                                                            })}
                                                        >
                                                            ✏️ Edit
                                                        </button>
                                                    )}

                                                </div>
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr><td colSpan="7" className="text-center py-4 text-muted">No transactions found</td></tr>
                                    )}
                                </tbody>
                            </table>

                            {/* Pagination */}
                            {pagination.totalPages > 1 && (
                                <div className="d-flex justify-content-between align-items-center p-3 border-top bg-light">
                                    <div className="small text-muted">Page <b>{pagination.currentPage}</b> of <b>{pagination.totalPages}</b></div>
                                    <div className="d-flex gap-1">
                                        <button className="pagination-btn" disabled={pagination.currentPage === 1} onClick={() => handlePageChange(pagination.currentPage - 1)}>Prev</button>
                                        {getPageNumbers().map((p, idx) => (
                                            <button key={idx} className={`pagination-btn ${p === pagination.currentPage ? 'active' : ''}`} disabled={p === '...'} onClick={() => typeof p === 'number' && handlePageChange(p)}>{p}</button>
                                        ))}
                                        <button className="pagination-btn" disabled={pagination.currentPage === pagination.totalPages} onClick={() => handlePageChange(pagination.currentPage + 1)}>Next</button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>

            

            {/* 🔥 DEVICE SELECTION MODAL */}
{showDeviceSelectionModal && (
    <div className="custom-modal-overlay">
        <div className="custom-modal" style={{ maxWidth: '500px' }}> {/* Width একটু বাড়ানো হয়েছে */}
            <div className="modal-header-custom" style={{ background: '#f8fafc' }}>
                <h5 className="mb-0">📱 Select Device & Method</h5>
                <button 
                    onClick={() => setShowDeviceSelectionModal(false)}
                    style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#64748b' }}
                >
                    ✕
                </button>
            </div>
            
            <div className="modal-body-custom p-0" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                {/* Clear Option */}
                <div 
                    className="p-3 border-bottom text-center text-danger" 
                    style={{ cursor: 'pointer', background: '#fff0f0', fontWeight: '600', fontSize: '13px' }}
                    onClick={() => {
                        setFormData({ ...formData, device_info: '' });
                        setShowDeviceSelectionModal(false);
                    }}
                >
                    🚫 Clear Selection
                </div>

                {devices
                    .sort((a, b) => (b.mobileOnline === true ? 1 : 0) - (a.mobileOnline === true ? 1 : 0))
                    .map(d => {
                        const s1 = getSimInfo(d.sim1);
                        const s2 = getSimInfo(d.sim2);
                        const allOptions = [];

                        const createListItems = (simData, slotName) => {
                            if(simData && simData.number && simData.types) {
                                simData.types.forEach((t, idx) => {
                                    // Number Masking
                                    const maskedNumber = simData.number.length > 3 
                                        ? "***" + simData.number.slice(-3) 
                                        : simData.number;

                                    // Logo Logic
                                    let logoPath = '/logo.png';
                                    const tLower = t.type.toLowerCase();
                                    if(tLower.includes('bkash')) logoPath = '/bkash.jpg';
                                    else if(tLower.includes('nagad')) logoPath = '/nagad.png';
                                    else if(tLower.includes('whatsapp')) logoPath = '/whatsapp.png';

                                    // Check if currently selected
                                    const isSelected = formData.device_info === `${d._id}::${slotName}::${t.type}`;

                                    allOptions.push(
                                        <div 
                                            key={`${d._id}-${slotName}-${idx}`}
                                            className="d-flex align-items-center justify-content-between p-3 border-bottom"
                                            onClick={() => {
                                                setFormData({ ...formData, device_info: `${d._id}::${slotName}::${t.type}` });
                                                setShowDeviceSelectionModal(false);
                                            }}
                                            style={{ 
                                                cursor: 'pointer', 
                                                background: isSelected ? '#f0f9ff' : 'white',
                                                transition: '0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.background = '#f1f5f9'}
                                            onMouseLeave={(e) => e.currentTarget.style.background = isSelected ? '#f0f9ff' : 'white'}
                                        >
                                            <div className="d-flex align-items-center">
                                                <ResilientImage
                                                    src={logoPath} 
                                                    alt={t.type} 
                                                    style={{ width: '35px', height: '35px', objectFit: 'contain', marginRight: '15px', borderRadius: '50%', border: '1px solid #e2e8f0', padding: '2px' }} 
                                                />
                                                <div>
                                                    <div style={{fontWeight: 700, fontSize: '14px', color: '#334155'}}>
                                                        {d.mobileOnline ? '🟢' : '🔴'} {d.deviceName}
                                                    </div>
                                                    <div style={{fontSize: '12px', color: '#64748b', marginTop: '2px'}}>
                                                        {maskedNumber} <span style={{color: '#cbd5e1'}}>|</span> <span className="fw-bold text-uppercase" style={{color: '#0284c7'}}>{t.type}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {isSelected && <span style={{color: '#0284c7', fontSize: '18px'}}>✔</span>}
                                        </div>
                                    );
                                });
                            }
                        };

                        createListItems(s1, 'sim1');
                        createListItems(s2, 'sim2');

                        return <React.Fragment key={d._id}>{allOptions}</React.Fragment>;
                })}
                
                {devices.length === 0 && (
                    <div className="text-center p-4 text-muted">No Active Devices Found</div>
                )}
            </div>
        </div>
    </div>
)}

            {/* Confirm Modal */}
            {showConfirmModal && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal">
                        <div className="modal-header-custom" style={{ background: '#e0f2fe' }}>
                            <h5 className="mb-0">Confirm Transaction</h5>
                        </div>
                        <div className="modal-body-custom p-4">
                            <div className="info-row">
                                <span>Target Number:</span> 
                                <strong style={{ color: '#0369a1' }}>{formData.number}</strong>
                            </div>
                            
                            {formData.device_info && (
                                <div className="info-row">
                                    <span>Transaction Type:</span> 
                                    <strong className="text-uppercase text-primary">
                                        {formData.device_info.split('::')[2]?.replace('_', ' ') || 'UNKNOWN'}
                                    </strong>
                                </div>
                            )}

                            <div className="info-row">
                                <span>Amount:</span> 
                                <strong style={{ fontSize: '18px', color: '#16a34a' }}>৳{formData.amount}</strong>
                            </div>
                            
                            <hr className="my-2" style={{ borderTop: '1px dashed #cbd5e1' }} />
                            
                            {(() => {
                                if(!formData.device_info) return null;
                                
                                const parts = formData.device_info.split('::');
                                if(parts.length < 3) return null;

                                const [devId, slot] = parts;
                                const dev = devices.find(d => d._id === devId);
                                const simData = getSimInfo(dev ? dev[slot] : null);
                                
                                return (
                                    <>
                                        <div className="info-row">
                                            <span>Sending Device:</span> 
                                            <strong>{dev?.deviceName || 'Selected Device'}</strong>
                                        </div>
                                        <div className="info-row">
                                            <span>From SIM:</span> 
                                            <strong className="text-danger">
                                                {simData ? simData.number : 'Unknown'} ({slot === 'sim1' ? 'SIM 1' : 'SIM 2'})
                                            </strong>
                                        </div>
                                    </>
                                );
                            })()}

                            <p className="text-muted text-center mt-3 small" style={{ fontStyle: 'italic' }}>
                                সবকিছু ঠিক থাকলে "Confirm" বাটনে ক্লিক করুন।
                            </p>
                        </div>
                        <div className="modal-footer-custom d-flex">
                            <button className="modal-btn cancel flex-fill" onClick={() => setShowConfirmModal(false)}>Cancel</button>
                            <button className="modal-btn confirm flex-fill" onClick={confirmAndSubmit}>Confirm & Send</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Cancel Modal */}
            {cancelModal.show && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal shadow-lg">
                        <div className="modal-header-custom"><h5 className="mb-0 text-danger">⚠️ ক্যানসেল নিশ্চিত করুন</h5></div>
                        <div className="modal-body-custom p-4 text-center">
                            <p className="mb-0 fw-bold">আপনি কি নিশ্চিত যে এই ট্রানজেকশনটি ক্যানসেল করতে চান?</p>
                        </div>
                        <div className="modal-footer-custom d-flex">
                            <button className="modal-btn cancel flex-fill" onClick={() => setCancelModal({ show: false, logId: null })}>না</button>
                            <button className="modal-btn confirm flex-fill bg-danger text-white" onClick={handleCancelConfirm}>হ্যাঁ</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Change Device Modal */}
            {changeDeviceModal.show && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal">
                        <div className="modal-header-custom" style={{ background: '#f0f9ff' }}>
                            <h5 className="mb-0">🔄 Change Device & Retry</h5>
                        </div>
                        
                        <div className="modal-body-custom p-4">
                            <div className="transaction-summary mb-3 p-3" style={{ background: '#f8fafc', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
                                <div className="info-row">
                                    <span>Target Number:</span>
                                    <strong className="text-primary">{changeDeviceModal.targetNumber}</strong>
                                </div>
                                <div className="info-row">
                                    <span>Type:</span>
                                    <strong className="text-uppercase">{changeDeviceModal.type?.replace('_', ' ')}</strong>
                                </div>
                                <div className="info-row">
                                    <span>Amount:</span>
                                    <strong className="text-success">৳{changeDeviceModal.amount}</strong>
                                </div>
                            </div>

                            <hr className="my-3" />

                            <label className="field-label">SELECT NEW DEVICE / SIM / TYPE</label>
                            <select 
                                className="modern-input mt-1" 
                                value={changeDeviceModal.selectedDeviceInfo} 
                                onChange={(e) => setChangeDeviceModal({ ...changeDeviceModal, selectedDeviceInfo: e.target.value })}
                            >
                                <option value="">-- Choose Device & Type --</option>
                                {devices
                                    .sort((a, b) => (b.mobileOnline === true ? 1 : 0) - (a.mobileOnline === true ? 1 : 0))
                                    .map(d => {
                                    
                                    const s1 = getSimInfo(d.sim1);
                                    const s2 = getSimInfo(d.sim2);
                                    const options = [];

                                    const createOptions = (simData, slotName, labelSlot) => {
                                        if(simData && simData.number) {
                                            options.push(
                                                <option key={`${d._id}-${slotName}-app`} value={`${d._id}::${slotName}::bkash_App_cashin`}>
                                                     {d.mobileOnline ? '🟢' : '🔴'} {d.deviceName} - {labelSlot}: {simData.number} (Bkash App Cashin)
                                                </option>
                                            );
                                            if(simData.types && simData.types.length > 0) {
                                                simData.types.forEach((t, idx) => {
                                                    options.push(
                                                        <option key={`${d._id}-${slotName}-${idx}`} value={`${d._id}::${slotName}::${t.type}`}>
                                                             {d.mobileOnline ? '🟢' : '🔴'} {d.deviceName} - {labelSlot}: {simData.number} ({t.type})
                                                        </option>
                                                    );
                                                });
                                            }
                                        }
                                    };

                                    createOptions(s1, 'sim1', 'SIM 1');
                                    createOptions(s2, 'sim2', 'SIM 2');

                                    return <React.Fragment key={d._id}>{options}</React.Fragment>;
                                })}
                            </select>
                            
                            {changeDeviceModal.selectedDeviceInfo && (
                                <div className="mt-2 text-center">
                                    <small className="text-muted">
                                        Selected: <strong>{changeDeviceModal.selectedDeviceInfo.split('::')[1]}</strong> থেকে পুনরায় পাঠানো হবে।
                                    </small>
                                </div>
                            )}
                        </div>

                        <div className="modal-footer-custom d-flex">
                            <button 
                                className="modal-btn cancel flex-fill" 
                                onClick={() => setChangeDeviceModal({ show: false, logId: null, selectedDeviceInfo: '', amount: 0, targetNumber: '', type: '' })}
                            >
                                Close
                            </button>
                            <button 
                                className="modal-btn confirm flex-fill" 
                                style={{ background: '#0284c7' }} 
                                onClick={handleChangeDeviceSubmit}
                            >
                                Retry Now
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* 🔥 NEW EDIT TRANSACTION MODAL */}
            {editModal.show && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal">
                        <div className="modal-header-custom" style={{ background: '#fef3c7' }}>
                            <h5 className="mb-0 text-dark">✏️ Edit Transaction</h5>
                        </div>
                        <div className="modal-body-custom p-4">
                            
                            {/* Status Select */}
                            <div className="mb-3">
                                <label className="field-label">UPDATE STATUS</label>
                                <select 
                                    className="modern-input"
                                    value={editModal.status}
                                    onChange={(e) => setEditModal({ ...editModal, status: e.target.value })}
                                >
                                    <option value="pending">Pending</option>
                                    <option value="executing">Executing</option>
                                    <option value="success">Success</option>
                                    <option value="failed">Failed</option>
                                    <option value="cancel">Cancel</option>
                                </select>
                            </div>

                            {/* Response Message Input */}
                            <div className="mb-3">
                                <label className="field-label">UPDATE RESPONSE / SMS</label>
                                <textarea 
                                    className="modern-input"
                                    rows="3"
                                    placeholder="Type response message..."
                                    value={editModal.message}
                                    onChange={(e) => setEditModal({ ...editModal, message: e.target.value })}
                                ></textarea>
                            </div>

                        </div>
                        <div className="modal-footer-custom d-flex">
                            <button className="modal-btn cancel flex-fill" onClick={() => setEditModal({ show: false, logId: null })}>Close</button>
                            <button className="modal-btn confirm flex-fill" style={{ background: '#d97706' }} onClick={handleEditSubmit}>Update</button>
                        </div>
                    </div>
                </div>
            )}

        </Layout>
    );
};

export default PaymentSend;
